<template>
  <div class="page">
    <div class="sidebar">
      <JacketStyleSidebar v-if="activeMenuItem === JACKET_MENU.JACKET"/>
      <CollarSidebar v-else-if="activeMenuItem === JACKET_MENU.COLLAR"/>
      <BodySidebar v-else-if="activeMenuItem === JACKET_MENU.BODY"/>
      <SleevesSidebar v-else-if="activeMenuItem === JACKET_MENU.SLEEVES"/>
      <SnapsSidebar v-else-if="activeMenuItem === JACKET_MENU.SNAPS"/>
      <PocketsSidebar v-else-if="activeMenuItem === JACKET_MENU.POCKETS"/>
      <TrimSidebar v-else-if="activeMenuItem === JACKET_MENU.TRIM"/>
      <LiningSidebar v-else-if="activeMenuItem === JACKET_MENU.LINING"/>
    </div>

    <div class="page__content">
      <EditorNavigation
        :menu-items="jacketMenuItems"
        :active-item="activeMenuItem"
      />

      <slot name="canvas"></slot>

      <JacketViewSwitcher></JacketViewSwitcher>
    </div>
  </div>
</template>

<script>
import { JACKET_MENU } from '@/common/constants';
import EditorNavigation from '@/components/common/EditorNavigation.vue';
import JacketViewSwitcher from '@/components/jacket/JacketViewSwitcher.vue';
import JacketStyleSidebar from '@/components/jacket/sidebars/JacketStyleSidebar.vue';
import CollarSidebar from '@/components/jacket/sidebars/CollarSidebar.vue';
import BodySidebar from '@/components/jacket/sidebars/BodySidebar.vue';
import SleevesSidebar from '@/components/jacket/sidebars/SleevesSidebar.vue';
import TrimSidebar from '@/components/jacket/sidebars/TrimSidebar.vue';
import SnapsSidebar from '@/components/jacket/sidebars/SnapsSidebar.vue';
import PocketsSidebar from '@/components/jacket/sidebars/PocketsSidebar.vue';
import LiningSidebar from '@/components/jacket/sidebars/LiningSidebar.vue';

export default {
  name: 'JacketPage',
  components: {
    LiningSidebar,
    PocketsSidebar,
    SnapsSidebar,
    TrimSidebar,
    SleevesSidebar,
    BodySidebar,
    CollarSidebar,
    JacketStyleSidebar,
    JacketViewSwitcher,
    EditorNavigation,
  },

  data () {
    return {
      JACKET_MENU
    };
  },
  mounted () {
  },
  computed: {
    jacketType () {
      return this.$store.getters['design/getJacketType'];
    },

    jacketSide () {
      return this.$store.getters['ui/getJacketSide'];
    },

    jacketMenuItems () {
      return this.$store.getters['ui/getJacketMenu'](this.jacketSide);
    },

    activeMenuItem () {
      return this.$store.getters['ui/getActiveMenuItem'];
    }
  }
};
</script>

<style scoped>
</style>
